import { Pipe, PipeTransform } from "@angular/core";
import { Injectable } from '@angular/core';

@Pipe({ name: 'emptyCheck' })
@Injectable({ providedIn: 'root' })
export class EmptyCheckPipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        if (value == null || value == undefined || value === "") {
            return "-"
        } else {
            if (args.length > 0) {
                return value + args[0]
            } else {
                return value
            }
        }
    }
}